/**
 * @generated SignedSource<<af115e295931bfbb0c23d90dc034c084>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment";
};
export type BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment$key = {
  readonly " $data"?: BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "40fe413a3990d5f0e1d8e316ecaf15af";

export default node;
